var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectDetection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6223 11.3036L24.2927 8.52955L16.6705 2.3851L14.052 5.1851L11.3816 2.33325L3.70752 8.52955L6.37789 11.3036L3.70752 14.0777L6.61122 16.424V19.7425L14.026 25.6666L21.4279 19.7425V16.3851L24.2927 14.0907L21.6223 11.3036ZM14.0001 15.6203L8.60752 11.3036L14.0001 6.99992L19.4446 11.3036L14.0001 15.6203ZM20.4816 12.2629L22.102 13.9481L16.852 18.2518L15.1668 16.5536L20.4816 12.2629ZM16.852 4.36844L22.1927 8.65918L20.5205 10.3703L15.1668 6.06658L16.852 4.36844ZM11.2649 4.30362L12.9631 6.01473L7.47974 10.3703L5.85937 8.65918L11.2649 4.30362ZM7.47974 12.2629L12.9631 16.5925L11.252 18.3036L5.85937 13.9481L7.47974 12.2629ZM8.07604 17.6036L11.3816 20.274L13.326 18.2518V23.2425L8.14085 19.0425L8.07604 17.6036ZM19.976 19.0425L14.7909 23.1907V18.2518L16.6834 20.2221L19.989 17.6295V19.1073L19.976 19.0425Z",
    fill: "#FF8027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectDetection);
export default __webpack_public_path__ + "static/media/object-detection.6077baaf1659ea40861913cecaf7961f.svg";
export { ForwardRef as ReactComponent };